













import { Vue, Component } from 'vue-property-decorator'
import Table, { Config, Pagination } from './components/Table.vue'
import { ArtStudent } from '@/models/enroll/artStudent'
import { getQueryedList } from '@/api/enroll/artStudent'
import { notify } from '@/utils/notification'

@Component({
  components: { Table }
})
export default class ProjectInstance extends Vue {
  //todo 修改本页面按钮的权限
  InstantData: ArtStudent[] = []
  InstantCount = 0
  get Instantpagination(): Pagination {
    return {
      current: 1,
      pagesize: 10
    }
  }
  get InstantConfig(): Config {
    return {
      rowKey: 'id',
      total: this.InstantCount,
      selection: 'radio',
      maxHeight: 700,
      columns: [
        // { prop: 'id', label: 'ID', width: 80 },
        { prop: 'name', label: '学生姓名', width: 200, fixed: 'left' },
        {
          prop: 'sex',
          label: '性别',
          width: 100,
          formatter: this.formatterSex
        },
        { prop: 'telephone', label: '手机号码', width: 200 },
        { prop: 'idNumber', label: '身份证号', width: 300 },
        { prop: 'collegeExaminationNumber', label: '高考报名号', width: 300 },
        {
          prop: 'politicalLandscape',
          label: '政治面貌',
          width: 100
        },
        {
          prop: 'national',
          label: '民族',
          width: 100
        },
        {
          prop: 'option',
          label: '操作',
          type: {
            type: 'buttonGroup',
            group: [
              {
                event: 'ShowStage',
                text: '查看报名表',
                right: '',
                buttonType: 'success'
              },
              {
                event: 'ShowStage',
                text: '下载报名表',
                right: '',
                buttonType: 'success'
              },
              {
                event: 'ShowStage',
                text: '编辑',
                right: '',
                buttonType: 'success'
              }
            ],
            style: 'group',
            size: 'small'
          },
          width: 350,
          fixed: 'right'
        }
      ]
    }
  }

  stageVisable = false
  selectedInstId: string = ''

  created() {
    this.loadData(this.Instantpagination)
  }

  formatterSex(celValue: number) {
    if (celValue == 1) {
      return '男'
    } else return '女'
  }

  async loadData(pagination: Pagination) {
    try {
      let limit = pagination.pagesize
      let offset = pagination.pagesize * (pagination.current - 1)
      const { rows, total } = await getQueryedList(limit, offset)
      this.InstantCount = total
      this.InstantData = rows
    } catch (e) {
      notify('获取数据失败', e)
    }
    return this.InstantData
  }

  async onButtonClick($event: any) {
    switch ($event.event) {
      case 'ShowStage': {
        this.stageVisable = true
        this.selectedInstId = $event.row.id
        return
      }
      default:
        break
    }
  }
}
